export default __webpack_public_path__ + "static/136-89f332fde271d3e152331aec774d1f62.jpg";